import { Component, inject, signal } from '@angular/core';
import { DISABILITY_PROOF_SERVICE, DisabilityProofService } from '../../../../api/services/disability-proof.service';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogContent,
	MatDialogActions,
	MatDialogTitle,
	MatDialogClose,
} from '@angular/material/dialog';
import { NOTIFICATION_SERVICE } from '../../../../shared/notification/notification';
import { DisabilityProof } from '../../../../api/app-types/disability-proof.app';
import {
	createErrorNotification,
	createSuccessNotification,
} from '../../../../shared/notification/notification.factory';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';

@Component({
	selector: 'lvr-disability-proof-delete-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	templateUrl: './disability-proof-delete-dialog.html',
	providers: [
		{
			provide: DISABILITY_PROOF_SERVICE,
			useClass: DisabilityProofService,
		},
	],
})
export class DisabilityProofDeleteDialog {
	private readonly api = inject(DISABILITY_PROOF_SERVICE);
	private readonly dialogRef = inject(MatDialogRef<DisabilityProofDeleteDialog>);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly data: { proof: DisabilityProof; clientId: number; onDeleted: () => Promise<void> } =
		inject(MAT_DIALOG_DATA);
	public readonly proof = this.data.proof;
	public readonly loading = signal(false);

	public async deleteProof() {
		this.loading.set(true);

		try {
			await this.api.delete(this.data.clientId, this.data.proof.id);
			await this.data.onDeleted();
			this.ntfySrv.addNotification(createSuccessNotification('Nachweis der Behinderung wurde erfolgreich gelöscht'));
			this.dialogRef.close(true);
		} catch {
			this.ntfySrv.addNotification(createErrorNotification('Fehler bei der Löschung des Nachweises der Behinderung'));
		} finally {
			this.loading.set(false);
		}
	}
}
